// The application (frontend/FlipAd) is served from its own Firebase Hosting site —
// a different origin from this website (see firebase.json's two hosting
// targets, "flipad-app" and "website"). Every link that used to be a
// same-origin path like "/auth" or "/inventory" has to cross origins now.
//
// Derived from VITE_STAGING rather than a separate override var, mirroring
// frontend/FlipAd's own convention (src/utils/currentTime.js, src/firebase/*.js,
// etc.) — both projects build from the same root .env, written by the same
// Cloud Build write-env step per environment (see deployments/cloudbuild.deploy.
// {dev,uat,prod}.yaml), so VITE_STAGING is already set correctly here for free.
// Site IDs come straight from .firebaserc's per-project hosting targets — the
// default *.web.app URL a Firebase Hosting site always keeps, even if a custom
// domain is later attached on top.
const STAGING = import.meta.env.VITE_STAGING;

const APP_URL_BY_STAGING = {
  local: 'http://localhost:5173',
  development: 'https://flipad-app-dev.web.app',
  uat: 'https://flipad-app-uat.web.app',
  production: 'https://flipad-app.web.app',
};

// Unset/unrecognized STAGING (e.g. running `vite` locally with no env at all)
// falls back to the app's default local dev port, same as running it live.
const APP_URL = (APP_URL_BY_STAGING[STAGING] || 'http://localhost:5173').replace(/\/$/, '');

export function appUrl(path = '') {
  return `${APP_URL}${path}`;
}

// Play Store "internal testing" listing per environment — Sign in now sends
// visitors to install/open the Android app instead of the web app's /auth
// page. Keyed the same way as APP_URL_BY_STAGING above; `local` has no
// internal-test track of its own, so it shares the development link.
const PLAY_STORE_URL_BY_STAGING = {
  local: 'https://play.google.com/apps/internaltest/4701341273858095673',
  development: 'https://play.google.com/apps/internaltest/4701341273858095673',
  uat: 'https://play.google.com/apps/internaltest/4700946925642919768',
  production: 'https://play.google.com/apps/internaltest/4701608093001015705',
};

export function playStoreUrl() {
  return PLAY_STORE_URL_BY_STAGING[STAGING] || PLAY_STORE_URL_BY_STAGING.development;
}

// Cross-app buttons (not plain <a> tags, so no href for the browser to open
// natively) go through this so the app opens in its own tab, leaving the
// marketing site where the visitor left it — noopener since the opened tab
// is a different origin.
export function openApp(path = '') {
  window.open(appUrl(path), '_blank', 'noopener');
}

// Same as openApp above, but for <button>-based CTAs whose target is now the
// Play Store instead of the web app.
export function openPlayStore() {
  window.open(playStoreUrl(), '_blank', 'noopener');
}
